module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Nenhuma contestação encontrada","description":"Escolha outros filtros disponíveis e tente de novo."},"en-US":{"title":"No disputes found","description":"Choose another filter method and try again."}}')
  delete Component.options._Ctor
}
